export default __webpack_public_path__ + "static/Chimney-Removal-b331370babba6b540d3d2869e818ac11.jpg";